import { useState, useCallback } from "react";
import {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
} from "../API/endpoint";

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadUsers = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getUsers();
      setUsers(data);
      setError("");
    } catch (err) {
      setError("Erreur lors du chargement des utilisateurs");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleCreateUser = useCallback(async (userData) => {
    try {
      await createUser(userData);
      await loadUsers();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors de la création de l'utilisateur");
      console.error(err);
      return false;
    }
  }, [loadUsers]);

  const handleUpdateUser = useCallback(async (id, userData) => {
    try {
      await updateUser(id, userData);
      await loadUsers();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors de la mise à jour de l'utilisateur");
      console.error(err);
      return false;
    }
  }, [loadUsers]);

  const handleDeleteUser = useCallback(async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?")) {
      try {
        await deleteUser(id);
        await loadUsers();
        setError("");
        return true;
      } catch (err) {
        setError("Erreur lors de la suppression de l'utilisateur");
        console.error(err);
        return false;
      }
    }
    return false;
  }, [loadUsers]);

  return {
    users,
    loading,
    error,
    setError,
    loadUsers,
    handleCreateUser,
    handleUpdateUser,
    handleDeleteUser,
  };
};
